import { displayHost as sharedDisplayHost } from "@passwordflow/domains";

const SCHEME_PREFIX = /^[a-z][a-z0-9+.-]*:\/\//i;
const BARE_HOST = /^[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}(:\d+)?(\/|$)/i;

/**
 * Returns a link target only for http(s) URLs. Anything else (javascript:, data:, junk)
 * yields undefined so the UI never renders an unsafe href.
 */
export function safeHttpUrl(raw: string): string | undefined {
  const value = raw.trim();
  if (value === "") {
    return undefined;
  }
  let candidate: string | undefined;
  if (SCHEME_PREFIX.test(value)) {
    candidate = value;
  } else if (BARE_HOST.test(value)) {
    candidate = `https://${value}`;
  }
  if (candidate === undefined) {
    return undefined;
  }
  try {
    const url = new URL(candidate);
    if (url.protocol !== "http:" && url.protocol !== "https:") {
      return undefined;
    }
    return url.toString();
  } catch {
    return undefined;
  }
}

/** Host for the UI. "www." is dropped only above a public suffix ("www.github.io" stays), as in the extension. */
export function displayHost(raw: string): string | undefined {
  const link = safeHttpUrl(raw);
  return link === undefined ? undefined : sharedDisplayHost(link);
}
